import classNames from 'classnames';
import * as React from 'react';
import { IFormValidationProperties } from '../../model/forms';
import { IFieldBaseProperties, IFieldValueProperties, IValidationProperties } from './interfaces';
import MonthYearDateField from './MonthYearDateField';
import FullDateField from './FullDateField';

export type DateFormat = 'FullDate' | 'MonthYear';

export interface IDateFieldProperties extends IFieldBaseProperties, IFieldValueProperties, IValidationProperties, IFormValidationProperties { 
  format?: DateFormat,
  max?: string,
  maxErrorMessage?: string
}

export class DateField extends React.PureComponent<IDateFieldProperties> {
  format: DateFormat

  constructor(props: IDateFieldProperties) {
    super(props);
    this.format = props.format || 'MonthYear';
  }

  render() {      
    let inputClasses = classNames({
      "hcs-text__input": true,
      "w-full": true,
      "input-validation-error": this.props.valid === false
    });
    
    switch (this.format) {
      case 'MonthYear':
        return <MonthYearDateField {...this.props} />;
      case 'FullDate':
        return <FullDateField {...this.props} />;
    }
  }
}

export default DateField;